const ChevronRight = (props) => {
  return (
    <svg width="5" height="8" viewBox="0 0 5 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.18178 4.00001L8.47993e-08 0.888878L0.909084 1.08407e-08L5 4.00001L0.909084 8L1.05999e-08 7.11111L3.18178 4.00001Z" fill="currentColor"/>
    </svg>
  );
};

export default ChevronRight;